import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;

  > img {
    max-width: 300px;
    height: auto;
  }

  > p {
    margin-top: 20px;
    font-size: 1.5rem;
    text-align: center;
  }

  ${props => props.theme.media.phone`
    > img {
      max-width: 250px;
    }

    > p {
      font-size: 1rem;
    }
  `}
`;

export default Container;
